import React, { Suspense } from "react";
import { Await, useLoaderData } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { PhishingDemoView } from "../../components/PhishingDemo/PhishingDemoView";

// The loader function that fetches data
export async function loader() {
    // For now, we'll return an empty object as we don't need any data yet
    return { };
}

const PhishingDemoPage: React.FC = () => {
    const data = useLoaderData() as { };

    return (
        <Suspense fallback={<CircularProgress/>}>
            <Await resolve={data}>
                {() => <PhishingDemoView />}
            </Await>
        </Suspense>
    );
};

export default PhishingDemoPage; 